import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import LayoutPage from "../Layout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { formatEastern } from "../../utils/easternDate";

const Contest = () => {
  const location = useLocation();
  const params = useParams();
  // console.log("Prediction ==> ", params);
  const [row, setRow] = useState([]);
  const [categoryData, setCategoryData] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const handlePerRowsChange = (number) => {
    setPageSize(number);
  };

  const handlePageChange = (number) => {
    setPageNumber(number);
  };

  const handleCloseButton = () => {
    navigate(-1);
  };

  const getCategoryData = useCallback(async () => {
    try {
      setLoading(true);
      axios
        .get(
          `admin/contestsList?pageNumber=${pageNumber}&pageSize=${pageSize}&sportsCategory=${params.id}`,
        )
        .then((res) => res.data.data)
        .then((data) => {
          setCategoryData(data.result);
          setRow(data);
          setLoading(false);
        });
    } catch (error) {
      // console.log("error", error);
    }
  }, [pageNumber, pageSize]);

  useEffect(() => {
    getCategoryData();
    if (location.state) {
      let msg = location.state.message;
      window.history.replaceState({}, document.title);
      navigate(location.pathname, { replace: true });
      toast(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
      });
    }
  }, [location, getCategoryData]);

  const dateChange = (dateString) => {
    const date = new Date(dateString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    // console.log("Date", date.setUTCDate());
    // return moment(dateString).format("MMMM DD, YYYY");
  };
  //Table collumns
  const columns = [
    {
      name: "Away Team",
      selector: (row) => row.awayTeam,
    },
    {
      name: "Home Team",
      selector: (row) => row.homeTeam,
    },

    {
      name: "Date",
      // selector: (row) => dateChange(row.date.substring(0, 10)),
      selector: (row) => formatEastern(row.contestDate),
      // moment(row.date).tz("America/New_York").format("MMM-DD-YYYY HH:mm​"),
    },
  ];

  const customStyle = {
    header: {
      style: {
        border: "1px solid gray",
      },
    },
    headRow: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
    rows: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
      },
    },
    pagination: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>Category Management</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex justify-content-between px-4">
                    <h6 className="text-white text-capitalize ps-2 custom-card-heading ">
                      {row.sportsName} Contest
                    </h6>
                    <i
                      className="fa fa-close fonts"
                      onClick={handleCloseButton}
                      style={{ cursor: "pointer", color: "white" }}
                    ></i>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <div className="input-group input-group-dynamic">
                    &nbsp; &nbsp;
                  </div>
                  {/* <h1>Sports Categories</h1> */}
                  <div className="table-responsive p-0">
                    <DataTable
                      columns={columns}
                      data={categoryData}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={row.total}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      sortServer
                      // onSort={handleSort}
                      customStyles={customStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
};

export default Contest;
